export default function useTransitionMixin() {
  return {
    methods: {
      //进入前，初始化需要过渡的属性
      beforeEnter: function(el) {
        // 初始化
        el.style.opacity = 0;
        el.style.transform = "scaleY(0)";
        el.style.transformOrigin = "top center";
      },
      //dom进入
      enter: function(el, done) {
        //获取文档可视区高度
        const htmlClientHeight = document.documentElement.clientHeight;
        //菜单列表相对于父元素的top偏移量
        const offsetTop = el.offsetTop;
        const scrollHeight = el.scrollHeight;
        //获取当前元素和可视区的一些长度（top,left,bottom等）
        const { bottom } = el.getBoundingClientRect();
        // 说明底部高度不够显示菜单了,这时候我们需要调整菜单朝上面显示
        if (htmlClientHeight - bottom < scrollHeight) {
          el.style.transformOrigin = "bottom center";
          el.style.top = -(scrollHeight + 10) + "px";
        } else {
          //查看是否placement属性，是的话我们主动处理
          if (this.$parent.placement == "top") {
            el.style.transformOrigin = "bottom center";
            el.style.top = -(scrollHeight + 10) + "px";
          } else {
            el.style.top = offsetTop + "px";
          }
        }
        el.style.transform = "scaleY(1)";
        el.style.opacity = 1;
        //根据官网事例，必须在enter和leave里面调用done函数，不然过渡动画不生效（切记）
        done();
      },
      //dom元素离开
      leave: function(el, done) {
        el.style.transform = "scaleY(0)";
        el.style.opacity = 0;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          //根据官网事例，必须在enter和leave里面调用done函数，不然过渡动画不生效（切记）
          done();
        }, 250);
      },
    },
  };
}
